export const appConfigMapping = {
  security: {
    securityDomains: (<any>window).appConfig
      ? (<any>window).appConfig.security.securityDomains
      : undefined,
    clientId: (<any>window).appConfig
      ? (<any>window).appConfig.security.clientId
      : undefined,
    autoConfigUrl: (<any>window).appConfig
      ? (<any>window).appConfig.security.autoConfigUrl
      : undefined
  },
  map: {
    mapboxintermodalToken: (<any>window).appConfig
      ? (<any>window).mapintermodalConstants.mapboxintermodalToken
      : undefined,
    mapintermodalStyleMono: (<any>window).appConfig
      ? (<any>window).mapintermodalConstants.mapintermodalStyleMono
      : undefined,
    mapintermodalStyleDark: (<any>window).appConfig
      ? (<any>window).mapintermodalConstants.mapintermodalStyleDark
      : undefined,
    mapintermodalStyleRoad: (<any>window).appConfig
      ? (<any>window).mapintermodalConstants.mapintermodalStyleRoad
      : undefined
  },
  api: {
    opsTrainApi: (<any>window).appConfig
      ? (<any>window).appConfig.api.opsTrainApi
      : undefined,
    rtopApi: (<any>window).appConfig
      ? (<any>window).appConfig.api.rtopApi
      : undefined,
      intermodalOperationsApi: (<any>window).appConfig
      ? (<any>window).appConfig.api.intermodalOperationsApi
      : undefined,
      reportApi: (<any>window).appConfig
      ? (<any>window).appConfig.api.reportApi
      : undefined,
      streamingDashboardAssetsApi: (<any>window).appConfig
      ? (<any>window).appConfig.api.streamingDashboardAssetsApi
      : undefined,
      userPreferencesApi: (<any>window).appConfig
      ? (<any>window).appConfig.api.userPreferencesApi
      : undefined,
  },
  webComponents: {
    home: (<any>window).appConfig
      ? (<any>window).appConfig.webComponents.home
      : undefined,
    realtimeOperationsInfo: (<any>window).appConfig
      ? (<any>window).appConfig.webComponents.realtimeOperationsInfo
      : undefined,
     realtimeTrainDetails: (<any>window).appConfig
      ? (<any>window).appConfig.webComponents.realtimeTrainDetails
      : undefined  
  },
  googleAnalyticsTrackingId: (<any>window).appConfig
    ? (<any>window).appConfig.googleAnalyticsTrackingId
    : undefined,
  googleAnalyticsURL: (<any>window).appConfig
    ? (<any>window).appConfig.googleAnalyticsURL
    : undefined,
  refreshInterval: (<any>window).appConfig
    ? (<any>window).appConfig.refreshInterval
    : undefined,
  enableStreaming: (<any>window).appConfig
    ? (<any>window).appConfig.enableStreaming
    : undefined,
  restartStreamingWhilePolling: (<any>window).appConfig
    ? (<any>window).appConfig.restartStreamingWhilePolling
    : undefined,
  trainLabelThresholdCount: (<any>window).appConfig
    ? (<any>window).appConfig.trainLabelThresholdCount
    : undefined,
  svgVersion: (<any>window).appConfig
    ? (<any>window).appConfig.svgVersion
    : undefined,
    itatUrl: (<any>window).appConfig
    ? (<any>window).appConfig.itatUrl
    : undefined,
    iohGateAvgTurnTimeMints: (<any>window).appConfig
    ? (<any>window).appConfig.iohGateAvgTurnTimeMints
    : undefined
};
